import { render } from "./DictionaryWord.vue?vue&type=template&id=e59a6174"
import script from "./DictionaryWord.vue?vue&type=script&lang=js"
export * from "./DictionaryWord.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__